// services/ReviewFolder/review.service.remote.js
import { httpService } from '../http.service.js'

export const reviewService = {
  query,
  getById,
  save,
  remove,
}

async function query(filterBy = {}) {
  try {
    const queryParams = new URLSearchParams(filterBy).toString()
    return await httpService.get(`review?${queryParams}`)
  } catch (err) {
    console.error('Failed to fetch reviews:', err)
    throw err
  }
}

async function getById(reviewId) {
  try {
    return await httpService.get(`review/${reviewId}`)
  } catch (err) {
    console.error(`Failed to get review with ID ${reviewId}:`, err)
    throw err
  }
}

async function save(review) {
  try {
    if (review._id) {
      return await httpService.put(`review/${review._id}`, review)
    } else {
      return await httpService.post('review', review)
    }
  } catch (err) {
    console.error('Failed to save review:', err)
    throw err
  }
}

async function remove(reviewId) {
  try {
    return await httpService.delete(`review/${reviewId}`)
  } catch (err) {
    console.error(`Failed to remove review with ID ${reviewId}:`, err)
    throw err
  }
}
